export var defaultConfig = {
    shouldIncludeAdminModule: true,
    apiBaseUrl: process.env.API_BASE_URL,
    // apiBaseUrl: 'http://localhost:6300/api',
    tokenKey: 'localStorage.token',
    appIdentifier: process.env.APP_IDENTIFIER,
    customerSecretKey: process.env.CUSTOMER_SECRET_KEY,
};
